<style lang="less" scoped>
  .expense-group-container{
    /*position: relative;*/
  }
  table{
    border-collapse:collapse;
  }
  table tr{
    border-bottom: 1px solid #dddee1;
  }
  table th, table td{
    border-right: 1px solid #dddee1;
  }
  .td-number{
    width: 200px;
    height: 24px;
    line-height: 24px;
    margin-top: -1px;
    vertical-align: top;
    padding: 0 7px;
    text-align: right;
    outline: 0;
    -moz-appearance: textfield;
    color: #666;
    border: 1px solid #dddee1;
    border-radius: 3px;
    transition: all .2s linear;
  }
  .fill-info-btn{
    color: #2d8cf6;
    text-decoration: underline;
    cursor: pointer;
  }
  .expense-group-table{
    /deep/ .ivu-table-expanded-cell {
      padding: 15px 20px;
    }
  }
</style>
<template>
  <div class="expense-group-container">
    <v-row
      dense
      style="max-width: 800px; margin: 0 auto"
    >
      <v-col>
        <v-select
          v-model="params.company_id"
          :items="companies"
          item-text="short_name"
          item-value="id"
          label="公司"
          clearable
          hide-details
          @change="doSearch"
        />
      </v-col>
      <v-col>
        <VTeamSelector
          v-model="params.team_id"
          label="团队"
          :placeholder="null"
          clearable
          hide-details
          @change="doSearch"
        />
      </v-col>
      <v-col>
        <v-select
          v-model="params.flow_node_id"
          :items="flow_nodes"
          item-text="name"
          item-value="id"
          label="流程节点"
          clearable
          hide-details
          @change="doSearch"
        />
      </v-col>
      <v-col>
        <v-select
          v-model="params.user_flow_node_status"
          :items="node_status_items"
          label="流程状态"
          clearable
          hide-details
          @click:clear="params.user_flow_node_status = -1"
          @change="doSearch"
        />
      </v-col>
      <v-col>
        <v-select
          v-model="params.order_sort"
          :items="[{value: 'asc', text: '时间升序'}]"
          label="排序(默认降序)"
          clearable
          hide-details
          @click:clear="params.order_sort = 'desc'"
          @change="doSearch"
        />
      </v-col>
      <v-col v-if="type===8">
        <v-select
          v-model="params.invoice_entered"
          :items="[{value: true, text: '已录入'},{value: false, text: '未录入'}]"
          label="校验状态"
          clearable
          hide-details
          @click:clear="params.order_sort = 'desc'"
          @change="doSearch"
        />
      </v-col>
      <v-col v-if="type === 1">
        <v-select
          v-model="params.status"
          :items="[{value: 'normal', text: '正常'},{value: 'deleted', text: '废弃'}]"
          label="单据状态"
          clearable
          hide-details
          @click:clear="params.order_sort = 'desc'"
          @change="doSearch"
        />
      </v-col>
      <v-col v-if="type === 1">
        <v-select
          v-model="params.payment_status"
          :items="[{value: 'finished', text: '已付款'},{value: 'unfinished', text: '未付款'}]"
          label="付款状态"
          clearable
          hide-details
          @click:clear="params.order_sort = 'desc'"
          @change="doSearch"
        />
      </v-col>
      <v-col v-if="type === 2">
        <v-checkbox
          label="待冲账"
          :value="params.need_reverse"
          hide-details
          @change="change_need_reverse"
        />
      </v-col>
    </v-row>

    <div
      class="text-center"
      style="margin-bottom: 20px"
    >
      <v-btn
        v-if="type===1&&selected_expense_groups.length"
        class="margin-r"
        color="amber"
        @click="batchGenerateBill"
      >
        批量生成账单
      </v-btn>
      <v-btn
        v-if="selected_expense_groups.length"
        class="margin-r"
        color="amber"
        @click="printExpenseGroups"
      >
        批量打印
      </v-btn>
      <space />
      <v-btn
        v-if="selected_expense_groups.length&&show_pay_btn"
        class="margin-r"
        color="amber"
        @click="payBatch"
      >
        批量通过
      </v-btn>
      <v-btn
        v-if="selected_expense_groups.length"
        class="margin-r"
        color="amber"
        @click="cancelMultipleChoice"
      >
        取消[{{ selected_expense_groups.length }}]
      </v-btn>
      <v-btn
        color="primary"
        @click="addExpenseGroup"
      >
        <v-icon>mdi-plus</v-icon>
        添加
      </v-btn>
      <space />
      <v-text-field
        v-model="params.search"
        :loading="data_loading"
        append-icon="mdi-magnify"
        hide-details
        placeholder="输入关键字搜索"
        class="margin-r"
        style="width: 280px; display: inline-block"
        clearable
        @click:append="doSearch"
        @click:clear="clearSearch"
        @keydown.enter="doSearch"
      />
      <Ajaxbtn
        v-show="false"
        ref="searchBtn"
        class="margin-r"
        :url="$util.api.es_query_expense_group"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleExpenseGroupData"
        @fail="handleExpenseGroupFail"
        @finally="data_loading = false"
        @click="stopContinuousFinishByBarCode"
      />
      <space style="margin-left: 80px" />
      <InvoiceEditor />
  
      <space />
      <FinModal 
        v-if="[1,8,9].includes(type)&&cur_customer.is_formal "
        ref="fin-modal"
        :type="type"
        title="工资付款单"
        button-title="生成工资付款单"
      />
      <FinExportModal v-if="type===8" />
      <!-- 只有付款单才显示 -->
      <!-- <FkGenerator v-if="type === 1 && cur_customer.is_formal" />
      <space />
      <FormalWageGenerator
        v-if="type === 1 && cur_customer.is_formal"
        :payment_type="1"
      />  -->
      <!-- 只有发票单显示 todo => add 非正式员工发票提交单 -->
      <!--  <space />
      <FormalWageGenerator
        v-if="type === 8 && cur_customer.is_formal"
        :payment_type="8"
      />  -->
      <!-- 只有账单单才显示 -->
      <!--  <space />
      <JtGenerator v-if="type === 9 && cur_customer.is_formal" />
      <space />
      <FormalWageGenerator
        v-if="type === 9 && cur_customer.is_formal"
        :payment_type="9"
      />
      <space />  -->
    </div>

    <Table
      ref="table"
      size="small"
      class="expense-group-table"
      :columns="expense_group_columns"
      :data="expense_groups"
      :loading="data_loading"
      @on-select-all="onSelectAll"
      @on-select-all-cancel="onSelectAllCancel"
      @on-select="onSelect"
      @on-select-cancel="onSelectCancel"
    />

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>

    <RichText
      :url="$util.api.update_expense_group_desc"
      :params="edit_expense_group"
      :config="rich_text_config"
      :text.sync="edit_expense_group.desc"
      @done="updateDescDone"
      @fail="updateDescFail"
    />
    <!-- 付款申请 -->
    <FkModal
      v-if="type===1"
      ref="editor"
      @success="()=>{
        pageChange(params.page)
      }"
    />
    <Editor
      v-if="type!==1"
      ref="editor"
      :type="type"
      role="financer"
      @update="updateExpenseGroup"
      :payeeFindKey="payeeFindKey"
      :payeeNoDataText="payeeNoDataText"
    />
    <ExpenseGroupRefundEditor
      ref="refundEditor"
      @refund="handleRefund"
    />

    <ExpenseGroupPrint
      v-if="[0,1,4,5,6,7,8,9].indexOf(type) > -1"
      ref="printer"
      :type="type"
    />
    <ExpenseGroupAdvancePrint
      v-if="type === 2"
      ref="advancePrinter"
    />
    <ExpenseGroupRechargePrint
      v-if="type === 3"
      ref="rechargePrinter"
    />
    <VOverlayLoading v-model="handle_loading" />
  </div>
</template>
<script>
  import {mapGetters} from "vuex";
  import FlowUtil from '../../libs/flow_util';
  import ExpenseUtil from '../../libs/expense_util';
  import FinBillUtil from '../fin_bill/libs/util';
  import fin_base from '../fin/mixins/fin_base';
  import VTeamSelector from '../team/components/v-selector';
  import VOverlayLoading from '../../vuetify_custom/v-overlay-loading';
  import ExpenseGroupExpand from '../fin/components/expense_group_expand';
  import ExpenseGroupUid from '../fin/components/expense_group_uid';
  import ExpenseGroupRefundEditor from '../fin/components/expanse_group_refund_editor';
  import Editor from './components/editor';

  import FkModal from '@/views/mine/components/fk_modal/index.jsx'
  import ExpenseGroupPrint from '../fin/components/expense_group_print';
  import ExpenseGroupAdvancePrint from '../fin/components/expense_group_advance_print';
  import ExpenseGroupRechargePrint from '../fin/components/expense_group_recharge_print';
  import UserFlowBase from '../components/flow/user_flow_base';
  import InvoiceEditor from '../invoice/components/invoice_editor';
  import FkGenerator from './components/fk_generator';
  import JtGenerator from './components/jt_generator';
  import { date_fields, generate_from_bill, register_hash } from './fields'
  import FinModal from './components/finmodal/index.jsx'
  import FinExportModal from './components/finmodal/FinExportModal.jsx'
  import Space from '../common/space.vue';
  import moment from 'moment';
  import { getsafe } from '@/libs/util.js'
  import {saveExpenseGroupTransformBatchApi, createExpenseGroupWriteOffApi} from '@/views/expense_group/services.js'
  import batch_pay_mixins from '@/views/expense_group/libs/batch_pay_mixins.js'

  export default {
    components: { VTeamSelector, VOverlayLoading, ExpenseGroupExpand, ExpenseGroupUid, ExpenseGroupRefundEditor,
                  Editor, ExpenseGroupPrint, ExpenseGroupAdvancePrint, ExpenseGroupRechargePrint,
                  UserFlowBase, InvoiceEditor, FkGenerator, JtGenerator, FinModal, Space, FkModal, FinExportModal },
    mixins: [fin_base, batch_pay_mixins],
    props: {
      type: {
        type: Number
      },
      check_link_report: {
        type: Boolean,
        default: true
      }
    },
    data() {
      const params = {
        per_page: 10,
        page: 1,
        search: '',
        team_id: 0,
        company_id: '0',
        flow_node_id: '-1',
        payment_type: this.type,
        user_flow_node_status: -1,
        order_sort: 'desc',
        payment_status: '',
        status: '',
        invoice_entered: null,
      }
      switch (this.type) {
      case 2:
        params.need_reverse = undefined
        break;
      case 1:
        params.payment_status = undefined
        params.status = undefined
        break;
      default:
        break;
      }
      return {
        date_fields: date_fields,
        data_loading: false,
        handle_loading: false,
        selected_expense_groups: [],
        params,
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        },
        node_status_items: [
          // {value: -1, text: '所有状态'},
          {value: 0, text: '进行中'},
          {value: 1, text: '通过/完成'},
        ],
        statuses: [
          {value: 0, content: '待财务审核'},
          {value: 5, content: '待付款'},
          {value: 9, content: '已完成'}
        ],
        show_editor: false,
        expense_groups: [],
        new_expense: ExpenseUtil.new_expense,
        edit_expense_group: {company_id: '', desc: ''},
        edit_desc_config: {
          modal: false,
          loading: true
        },
        rich_text_config: {
          show: false,
          title: ''
        },
        flow_nodes: [],
        payeeFindKey: this.type === 0 ? 'some_key' : 'search',
        payeeNoDataText: this.type === 0 ? '无申请人收款账户信息，请确认并完善相关信息' : '没有数据，请搜索'
      }
    },
    computed: {
      show_pay_btn() {
        const current_hash = this.$store.state.hash_authority || {}
        return this.type === 1 && current_hash['fin_batch_pay']
      },
      is_accounting_manager() {
        const current_hash = this.$store.state.hash_authority || {}
        return current_hash['fk_is_accounting_manager']
      },
      expense_group_columns() {
        const arr = [
          {
            type: 'selection',
            align: 'center',
            width: 30
          },
          {
            title: '展开',
            type: 'expand',
            align: 'center',
            width: 36,
            render: (h, params) => {
              return h(ExpenseGroupExpand, {
                props: {
                  type: this.type,
                  model_id:params.row.id,
                  canEdit: true
                }
              })
            }
          },
          {
            title: '编号',
            key: 'uid',
            width: 120,
            render: (h, params) => {
              const row = params.row;
              const ret = [h(ExpenseGroupUid, {
                props: {
                  expense_group: row
                }
              })]
              if (row.transform_from) {
                ret.push(
                  h('p', {
                    style: {
                      padding: 0,
                      margin: 0,
                   
                    },
                    class: 'color-info',
                  }, '[单据转换]')
                )
              }
              return h('div', ret) ;
            }
          },
          {
            title: '名称',
            key: 'name'
          },
          {
            title: '公司-团队',
            width: 80,
            render: (h, params) => {
              let company = '未设置';
              if (this.companies_hash[params.row.company_id]) {
                company = this.companies_hash[params.row.company_id].short_name;
              }
              let team = '未设置';
              if (this.teams_hash[params.row.team_id]) {
                team = this.teams_hash[params.row.team_id].name;
              }
              const ret = [];
              ret.push(h('div', {
                'class':{
                  'text-bold': true
                },
              }, company));
              ret.push(h('div', team));
              return h('div', ret);
            }
          },
          {
            title: '申请人',
            width: 120,
            key: 'apply_user',
            render: (h, params) => {
              const row = params.row;
              return <CustomerName id={ row.apply_user_id } />
            }
          },
          {
            title: '付款对象',
            key: 'payee_company',
            render: (h, params) => {
              const row = params.row;
              const ret = [row.payee_user || row.payee_company]
              const is_multi_payee = getsafe(row, 'multi_payee', false)
              if (this.type === 1 && row.can_cross_company) {
                ret.push(h('span', {class:'color-error', style:'margin-left:5px'}, ['[TGS]']))
              }
              if (is_multi_payee) {
                ret.push(h('span', {class:'color-error', style:'margin-left:5px'}, '[MV]'))
              }
              const register_nodes = []
              Object.keys(row.register_consistency || {}).forEach(key => {
                const title = register_hash[key]
                register_nodes.push(h('div', {
                  key:`${key}_${row.id}`,
                  style: {
                    color: !row.register_consistency[key] && 'red',
                  }
                }, `${title}${row.register_consistency[key] ? '一致' : '不一致'}`))
              })
              if (register_nodes.length) {
                ret.push(h('div', {}, [register_nodes]))
              }
             
         
              return h('div', ret)
             
            }
          },
          {
            title: '总金额',
            align: 'right',
            width: 110,
            key: 'total_price',
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('div', ExpenseUtil.getCurrencySymbol(row.currency) + this.$util.formatPrice(row.total_price)));
              return h('div', {
                'class': {
                  'text-right': true
                }
              }, ret);
            }
          },
          {
            title: '财务单据',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return <span>{ FinBillUtil.expenseGroupFinBillNames(row) || '无' }</span>
            }
          },
          {
            includes_types:[8],
            title: '校验状态',
            align: 'center',
            key: 'invoice_entered',
            render: (h, params) => {
              const row = params.row
              return <span>{row.invoice_entered ? '已录入' : '未录入'}</span>
            }
          },
          {
            title: '状态',
            width: 125,
            key: 'status',
            render: (h, params) => {
              const row = params.row;
              const user_flow = row.user_flow;
              if (user_flow) {
                return h(UserFlowBase, {
                  props: {
                    user_flow: user_flow,
                    model: row,
                    submitOutValid: () => {
                      if (this.type === 9 && !FinBillUtil.expenseGroupFinBillNames(row)) {
                        this.$vModal.warning({
                          title:'提示',
                          content: '该账单因缺少对应的财务单据，无法生成！'
                        })
                        return false
                      }
                      return true
                    }
                  }
                })
              }
              if (row.del) {
                return <div class="color-error">已废弃</div>;
              }
              if (row.status === 9) {
                return (
                  <div>
                    <span class="color-success">已完成: </span>
                    <span>{ row.finish_user } </span>
                    <span class="color-grey">{ this.$util.formatDate(row.finished_at) }</span>
                  </div>
                )
              } else {
                return <span>-</span>;
              }
            }
          },
          {
            title: '操作',
            align: 'center',
            width: 80,
            render: (h, params) => {
              const expense_group = params.row;
              const events_hash = {
                edit: {
                  label: '编辑',
                  handler: () => {
                    this.editExpenseGroup(expense_group);
                  }
                },
                print: {
                  label: '打印',
                  handler: () => {
                    this.printExpenseGroup(expense_group);
                  }
                },
                copy: {
                  label: '复制一份',
                  handler: () => {
                    this.copyExpenseGroup(expense_group);
                  }
                },
                gen_payment_expense_group: {
                  label: '生成付款申请单',
                  hide: ![8, 9].includes(this.type),
                  handler: () => {
                    this.genExpenseGroup(expense_group, 1);
                  }
                },
                gen_invoice_expense_group: {
                  label: '生成发票提交单',
                  hide: ![1, 9].includes(this.type),
                  handler: () => {
                    this.genExpenseGroup(expense_group, 8);
                  }
                },
                charge_against: {
                  label: '账单冲销',
                  hide: 9 !== this.type,
                  handler: () => {
                    if (!expense_group.user_flow || !expense_group.user_flow.is_finish) {
                      this.$vModal.warning({
                        title:'提示',
                        content: '只有完成的单据才能冲销！'
                      })
                      return 
                    }
                    this.$vModal.confirm({
                      title:'提示',
                      content: `确定冲销单据${expense_group.uid}`,
                      loading: true,
                      onOk:({
                        destroy,
                        stopLoading
                      }) => {
                        createExpenseGroupWriteOffApi({id:expense_group.id}).then(() => {
                          destroy()
                          this.$Message.success('数据提交成功！')
                          this.doSearch()
                        }).finally(() => {
                          stopLoading()
                        })
                      }
                    })
                  }
                },
                gen_bill_expense_group: {
                  label: '生成账单提交单',
                  hide: ![1, 8].includes(this.type),
                  handler: () => {
                    this.genExpenseGroup(expense_group, 9);
                  }
                },
                delete: {
                  label: '废弃',
                  divided: true,
                  handler: () => {
                    this.deleteExpenseGroup(expense_group);
                  }
                },
                refund: {
                  label: '银行退款',
                  hide: math.eval(`${expense_group.total_price} <= 0`),
                  handler: () => {
                    this.refundEdit(expense_group);
                  }
                }
              }
              const menu_list = [];
              Object.keys(events_hash).forEach((event_name) => {
                const event_label = events_hash[event_name].label;
                const divided = events_hash[event_name].divided;
                const hide = events_hash[event_name].hide;
                if (!hide) {
                  menu_list.push(h('DropdownItem', {
                    props:{
                      name: event_name,
                      divided: divided
                    }
                  }, event_label))
                }
              });
              return h('Dropdown', {
                props: {
                  trigger: 'click',
                  placement: 'left'
                },
                on: {
                  'on-click': (event_name) => {
                    events_hash[event_name].handler();
                  }
                }
              }, [
                h('div', {
                  class: {
                    link: true
                  }
                }, [
                  h('span', '操作'),
                  h('Icon', {
                    props: {
                      type: 'ios-arrow-down'
                    }
                  })
                ]),
                h('DropdownMenu', {
                  slot: 'list'
                }, menu_list)
              ]);
            }
          }
        ]
        return arr.filter(i => {
          if (i.includes_types) {
            return i.includes_types.includes(this.type)
          }
          return true
        })
      },
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      select_teams() {
        const teams = [];
        teams.push({id: 0, name: '所有团队'});
        this.teams.forEach((team) => {
          teams.push(team);
        });
        return teams;
      },
      ...mapGetters({
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash'
      }),
    },
    watch: {
      //
    },
    created() {
      //
    },
    mounted() {
      this.init();
      if (this.type === 9) { // 
        const data = JSON.parse(localStorage.getItem('contract_generate_bill')) 
        if (!data) {
          return 
        }
        localStorage.removeItem('contract_generate_bill');
        const data_form = generate_from_bill.reduce((total, key) => {
          total[key] = data[key]
          return total
        }, {})
        data_form.contract_id = data.id
        data_form.gen_by_contract = true
        this.editExpenseGroup(data_form)
        return 
      }
      if (this.type === 1) {
        let contract = JSON.parse(localStorage.getItem('contract_id_fk'));
        if (contract) {
          contract.is_out = false
        } else {
          contract = JSON.parse(localStorage.getItem('contract_id_outsource')) ;
          contract && (contract.is_out = true)
        }
        localStorage.removeItem('contract_id_outsource')
        localStorage.removeItem('contract_id_fk')
        if (contract) {
          this.editFromcontract(contract)
          return 
        }
       
      }
    },
    methods: {
      cancelMultipleChoice() {
        this.selected_expense_groups = []
        const tableData = this.$refs.table.objData
        Object.keys(tableData).forEach(key => {
          const item = tableData[key]
          item._isChecked = false
        })
        // console.log('this.$refs.table.objData', this.$refs.table.objData)
        // for (const item of this.$refs.table.objData) {
         
        //   item._isChecked = false
        // }
       
      },
      change_need_reverse(data) {
        this.params.need_reverse = data || undefined
        this.doSearch()
      },
      handleRefund(expense_group, refund_expense_group) {
        this.$util.insertOrUpdateArrayItem(this.expense_groups, expense_group, true);
        if (refund_expense_group) {
          this.$refs.editor.edit({
            ...refund_expense_group,
            paid_at: moment().format('YYYY-MM-DD')
          });
        }
      },
      onSelectAll(selection) {
        selection.forEach(row => {
          if (!this.selected_expense_groups.find(expense_group => expense_group.id === row.id)) {
            this.selected_expense_groups.push(row)
          }
        })
      },
      onSelect(selection, row) {
        this.selected_expense_groups.push(row)
      },
      onSelectAllCancel(selection) {
        this.selected_expense_groups = selection
      },
      onSelectCancel(selection, row) {
        const index = this.selected_expense_groups.findIndex(expense_group => expense_group.id === row.id)
        this.selected_expense_groups.splice(index, 1)
      },
      init() {
        this.doSearch();
        this.getFlowInfo();
      },
      getFlowInfo() {
        const link_model = ExpenseUtil.getModalName(this.type);
        this.$util.ajax.get(this.$util.api.get_flow_by_link_model, {
          params: {
            link_model: link_model
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            data.nodes.forEach((node) => {
              this.flow_nodes.push(node);
            });
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      beforeSearch() {
        this.params.page = 1;
        this.data_loading = true;
      },
      pageChange(new_page) {
        this.data_loading = true;
        this.params.page = new_page;
        this.$refs.searchBtn.doAjax(true);
      },
      doSearch() {
        this.params.page = 1;
        this.$nextTick(() => {
          this.$refs.searchBtn.doAjax();
        })
      
      },
      clearSearch() {
        this.params.search = '';
        this.doSearch();
      },
      handleExpenseGroupData(data) {
        this.expense_groups = [];
        data.expense_groups.forEach((expense_group) => {
          if (!expense_group.desc) {
            expense_group.desc = '';
          }
          if (this.selected_expense_groups.find(selected => selected.id === expense_group.id)) {
            expense_group._checked = true
          }
          this.expense_groups.push(expense_group);
        });
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
        this.getBarCodeResultCallback && this.getBarCodeResultCallback();
      },
      handleExpenseGroupFail(e) {
        this.$Message.error('获取失败: ' + e);
        console.log(e);
      },
      handleOtherEvent(event_name) {
        switch (event_name) {
        case 'continuous-finish':
          this.finishByBarCode();
          break;
        case 'export-order':
          this.exportOrderToPay();
          break;
        default:
          this.$Message.error('未定义操作!');
          break;
        }
      },
      addExpenseGroup() {
        this.$refs.editor.edit();
      },
      editExpenseGroup(expense_group) {
        if (this.type === 1) {
          const is_not_finish = !expense_group.user_flow || !expense_group.user_flow.is_finish
          if (is_not_finish || this.is_accounting_manager) {
            this.$refs.editor.edit(expense_group);
            return
          }
          this.$vModal.warning({
            title: '提示',
            content: '该付款申请已完结，不能再次编辑！'
          })
          return 
        }
        this.$refs.editor.edit(expense_group);
      },
      editFromcontract(contract) {
        this.$refs.editor.generateFromContract(contract);
      },
      batchGenerateBill() {
        this.$vModal.confirm({
          title: '提示',
          render: (h) => {
            return h('div', [
              h('div', this.selected_expense_groups.map(i => i.uid).join('、')),
              h('div', '生成账单账单提交单？'),
            ])
          },
          loading:true,
          onOk:({
            destroy,
            stopLoading
          }) => {
            saveExpenseGroupTransformBatchApi({
              ids: this.selected_expense_groups.map(i => i.id),
              new_payment_type: 9
            }).then(res => {
              setTimeout(() => {
                this.$vModal.confirm({
                  title: '提示',
                  render: (h) => {
                    return h('div', [
                      h('div', `总共${res.total_count}条`),
                      h('div', `成功${res.success_count}条`),
                    ])
                  },
                  okText:'转至账单提交单',
                  onOk:() => {
                    window.open('/fin/expense_group_bill')
                  }
                })
              }, 200)
              destroy()
            }).finally(() => {
              stopLoading()
            })
          }           
        })
      },
      printExpenseGroups() {
        const selected_expense_groups = this.selected_expense_groups
        let has_no_finish_node = false
        selected_expense_groups.forEach(expense_group => {
          if (!FlowUtil.inFinishNode(expense_group)) {
            has_no_finish_node = true
          }
        })
        if (has_no_finish_node) {
          this.$Modal.warning({title: '提示', content: '含有非打印节点'});
          return
        }
        if (this.type === 2) {
          this.$refs.advancePrinter.print_expense_groups(selected_expense_groups);
        } else if (this.type === 3) {
          this.$refs.rechargePrinter.print_expense_groups(selected_expense_groups)
        } else {
          this.$refs.printer.print_expense_groups(selected_expense_groups)
        }
      },
      printExpenseGroup(expense_group) {
        if (expense_group.user_flow.is_finish/* FlowUtil.inFinishNode(expense_group) */) {
          if (this.type === 2) {
            this.$refs.advancePrinter.print(expense_group);
          } else if (this.type === 3) {
            this.$refs.rechargePrinter.print(expense_group);
          } else {
            this.$refs.printer.print(expense_group);
          }
        } else {
          this.$Modal.warning({title: '提示', content: '非打印节点'});
        }
      },
      refundEdit(expense_group) {
        this.$refs.refundEditor.edit(expense_group);
      },
      copyExpenseGroup(expense_group) {
        this.$refs.editor.copy(expense_group);
      },
      genExpenseGroup(expense_group, new_payment_type) {
        this.handle_loading = true;
        this.$http.post('expense_group/transform_payment_type', {
          from_id: expense_group.id,
          new_payment_type
        }).then((data) => {
          console.log(data);
          if (new_payment_type === 1) {
            eventHub.$emit('go-to-path', '/fin/expense_group_company');
          } else if (new_payment_type === 8) {
            eventHub.$emit('go-to-path', '/fin/expense_group_invoice');
          } else if (new_payment_type === 9) {
            const expense_group = data.expense_group || {}
            this.$vModal.confirm({
              title: '提示',
              content: `已成功生成账单提交单${expense_group.uid}`,
              okText: '转至账单提交单',
              cancelText: '关闭',
              onOk:() => {
                window.open('/fin/expense_group_bill')
              },
            })
          //   eventHub.$emit('go-to-path', '/fin/expense_group_bill');
          }
        }).catch((e) => {
          console.log(e);
        }).finally(() => {
          this.handle_loading = false;
        })
      },
      deleteExpenseGroup(expense_group) {
        let del_reason = '';
        this.$Modal.confirm({
          title: '提示',
          render: (h) => {
            return h('div', [
              h('div', {
                class: {
                  'line': true,
                  'color-error': true
                }
              }, `你确定要废弃 ${expense_group.name} 吗?`),
              h('Input', {
                props: {
                  value: del_reason,
                  type: 'textarea',
                  maxlength: 200,
                  autofocus: true,
                  placeholder: '请输入废弃的原因'
                },
                on: {
                  input: (val) => {
                    del_reason = val;
                  }
                }
              })
            ]);
          },
          onOk: () => {
            if (!del_reason.trim()) {
              this.$Message.error('请输入废弃的原因?');
              setTimeout(() => {
                this.deleteExpenseGroup(expense_group);
              }, 500);
              return;
            }
            this.$util.ajax.post(this.$util.api.delete_expense_group, {
              id: expense_group.id,
              del_reason: del_reason
            }).then((response) => {
              return response.data;
            }).then((res) => {
              if (res.code === 1) {
                expense_group.del = true;
                this.$Message.success('废弃成功!');
              } else {
                this.$Modal.error({title: '提示', content: res.msg});
              }
            }).catch((e) => {
              this.$Modal.error({title: '提示', content: e.message});
            });
          }
        })
      },
      updateExpenseGroup(expense_group) {
        if (expense_group.user_flow) {
          this.$util.insertOrUpdateArrayItem(this.expense_groups, expense_group, true);
        } else {
          this.doSearch();
        }
      },
      editDesc(expense_group) {
        this.edit_expense_group = this.$util.clone(expense_group);
        this.rich_text_config.show = true;
        this.rich_text_config.title = expense_group.name;
      },
      updateDescDone(data) {
        if (data.code === 1) {
          this.edit_desc_config.modal = false;
          this.$Message.success('修改备注成功!');
          this.$util.insertOrUpdateArrayItem(this.expense_groups, data.expense_group);
        } else {
          this.$Message.error(data.msg);
        }
      },
      updateDescFail() {
        this.$Message.error('修改备注失败!');
      },
      searchByBarCode() {
        this.stopContinuousFinishByBarCode();
        eventHub.$emit('show-qr-scaner', (data) => {
          this.params.search = data;
          this.doSearch();
          setTimeout(() => {
            this.params.search = '';
          }, 100);
        });
      },
      finishByBarCode() {
        this.startContinuousFinishByBarCode();
        eventHub.$emit('show-qr-scaner', (data) => {
          this.params.search = data;
          this.doSearch();
          setTimeout(() => {
            this.params.search = '';
          }, 100);
        });
      },
      startContinuousFinishByBarCode() {
        console.log('start continuous scan');
        this.getBarCodeResultCallback = () => {
          setTimeout(() => {
            if (this.expense_groups.length === 1) {
              const expense_group = this.expense_groups[0];
              if (expense_group.status === 5) {
                this.setBanks(expense_group, 0);
              } else {
                this.$Message.error('该单据不是待完成状态!');
              }
            }
          }, 100);
        };
        this.finishExpenseGroupCallback = () => {
          this.finishByBarCode();
        };
      },
      stopContinuousFinishByBarCode() {
        console.log('stop continuous scan');
        this.getBarCodeResultCallback = null;
        this.finishExpenseGroupCallback = null;
      },
      exportOrderToPay() {
        this.$router.push('/fin/expense_group_export_to_pay');
      }
    }
  }
</script>
